// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import base_url from "../config/Config";
// import Navigation from "../components/Navigation";
// import Sidebar from "../components/Sidebar";

// const Permissions = () => {
//   const token = Cookies.get("authToken");
//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState("");
//   const [tabs, setTabs] = useState([]);

//   // Fetch users
//   useEffect(() => {
//     axios
//       .get(`${base_url}/api/auth/users`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => setUsers(res.data || []))
//       .catch(() => alert("Failed to fetch users"));
//   }, [token]);

//   // Fetch tabs for selected user
//   useEffect(() => {
//     if (!selectedUser) return;
//     axios
//       .get(`${base_url}/api/auth/tabs/${selectedUser}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => setTabs(res.data || []))
//       .catch(() => alert("Failed to fetch tabs"));
//   }, [selectedUser, token]);

//   const handleUserChange = (e) => {
//     setSelectedUser(e.target.value);
//     setTabs([]);
//   };

//   const togglePermission = (index, perm) => {
//     const newTabs = [...tabs];
//     newTabs[index][perm] = !newTabs[index][perm];
//     setTabs(newTabs);
//   };

//   const handleSave = () => {
//     if (!selectedUser) return alert("Select a user!");
//     axios
//       .post(`${base_url}/api/auth/assignTabPermissions/${selectedUser}`, tabs, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       })
//       .then(() => alert("Permissions saved!"))
//       .catch(() => alert("Failed to save permissions"));
//   };

//   return (
//     <div>
//       {/* Header */}
//       <div className="overviewsaa">
//         <h4>Customer Details</h4>
//       </div>

//       {/* Top Navigation */}
//       <div className="navigationss mb-5">
//         <Navigation />
//       </div>

//       <div className="container-fluid">
//         <div className="row">
//           {/* Sidebar */}
//           <div className="col-lg-2 col-md-2 sidebarnavigartion">
//             <div className="lmssidebar">
//               <Sidebar />
//             </div>
//           </div>

//           {/* Main Content */}
//           <div className="col-lg-10 col-md-9">
//             <div style={{ padding: "20px" }}>
//               <h4>User Permissions</h4>

//               {/* User Dropdown */}
//               <div className="permission" style={{ margin: "15px 0" }}>
//                 <select
//                   value={selectedUser}
//                   onChange={handleUserChange}
//                   className="form-select"
//                 >
//                   <option value="">-- Select User --</option>
//                   {users.map((user, i) => (
//                     <option key={i} value={user}>
//                       {user}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Tabs Permission Table */}
//               {tabs.length > 0 ? (
//                 <>
//                   <table
//                     border="1"
//                     cellPadding="8"
//                     cellSpacing="0"
//                     style={{ width: "100%", marginBottom: "20px" }}
//                   >
//                     <thead>
//                       <tr>
//                         <th>S.No.</th>
//                         <th>Tab Name</th>
//                         <th>View</th>
//                         <th>Edit</th>
//                         <th>Delete</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tabs.map((tab, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{tab.tabName}</td>
//                           <td style={{ textAlign: "center" }}>
//                             <input
//                               type="checkbox"
//                               checked={tab.canView}
//                               onChange={() => togglePermission(i, "canView")}
//                             />
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             <input
//                               type="checkbox"
//                               checked={tab.canEdit}
//                               onChange={() => togglePermission(i, "canEdit")}
//                             />
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             <input
//                               type="checkbox"
//                               checked={tab.canDelete}
//                               onChange={() => togglePermission(i, "canDelete")}
//                             />
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>

//                   {/* Save Button */}
//                   <button
//                     type="submit"
//                     onClick={handleSave}
//                     className="btn btn-primary mt-2"
//                   >
//                     Save Permissions
//                   </button>
//                 </>
//               ) : (
//                 selectedUser && <p>No tabs found for this user.</p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Permissions;



import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import base_url from "../config/Config";
import Navigation from "../components/Navigation";
import Sidebar from "../components/Sidebar";

const Permissions = () => {
  const token = Cookies.get("authToken");
  // const role = Cookies.get("userRole");

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [allTabs, setAllTabs] = useState([]);
  const [userTabs, setUserTabs] = useState([]);
  const [loading, setLoading] = useState(true);
const adminId = localStorage.getItem("adminId") || "";

  // ✅ Hooks must always be called
  useEffect(() => {
    axios
      .get(`${base_url}/api/auth/users`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setUsers(res.data || []))
      .catch(() => alert("Failed to fetch users"));
  }, [token]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${base_url}/api/auth/allTabs`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const formatted = (res.data || []).map((t) => ({
          tabName: typeof t === "string" ? t : t.tabName || "",
          canView: false,
          canEdit: false,
          canDelete: false,
        }));
        setAllTabs(formatted);
        setUserTabs(formatted);
      })
      .catch(() => {
        setAllTabs([]);
        setUserTabs([]);
        alert("Failed to fetch tabs list");
      })
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    if (!selectedUser) {
      setUserTabs(allTabs);
      return;
    }
    setLoading(true);
    axios
      .get(`${base_url}/api/auth/tabs/${selectedUser}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const userData = res.data || [];
        const merged = allTabs.map((tab) => {
          const found = userData.find((u) => u.tabName === tab.tabName);
          return found
            ? { ...tab, ...found }
            : { ...tab, canView: false, canEdit: false, canDelete: false };
        });
        setUserTabs(merged);
      })
      .catch(() => setUserTabs(allTabs))
      .finally(() => setLoading(false));
  }, [selectedUser, allTabs, token]);

  const handleUserChange = (e) => setSelectedUser(e.target.value);

  const togglePermission = (index, perm) => {
    const updated = [...userTabs];
    updated[index][perm] = !updated[index][perm];
    setUserTabs(updated);
  };

  const handleSave = () => {
    if (!selectedUser) return alert("Select a user first!");
    axios
      .post(`${base_url}/api/auth/assignTabPermissions/${selectedUser}`, userTabs, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(() => alert("Permissions saved successfully!"))
      .catch(() => alert("Failed to save permissions"));
  };

if (!adminId || !["UJJAWALSRIJAN", "SUPERADMIN"].includes(adminId.toUpperCase())) {

  return (
    <div className="text-center mt-5">
      <h3>Access Denied</h3>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}


  return (
    <div>
      <div className="overviewsaa">
        <h4>Customer Details</h4>
      </div>

      <div className="navigationss mb-5">
        <Navigation />
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-2 sidebarnavigartion">
            <div className="lmssidebar">
              <Sidebar />
            </div>
          </div>

          <div className="col-lg-10 col-md-9">
            <div style={{ padding: "20px" }}>
              <h4>User Permissions</h4>

              <div className="permission mb-3">
                <select
                  value={selectedUser}
                  onChange={handleUserChange}
                  className="form-select"
                >
                  <option value="">-- Select User --</option>
                  {users.map((user, i) => (
                    <option key={i} value={user}>
                      {user}
                    </option>
                  ))}
                </select>
              </div>

              {loading ? (
                <p>Loading tabs...</p>
              ) : (
                <>
                  <table
                    className="table permissiontable table-bordered text-center"
                    style={{ marginBottom: "20px" }}
                  >
                    <thead className="table-light text-center">
                      <tr>
                        <th>#</th>
                        <th>Tab Name</th>
                        <th>View</th>
                        <th>Edit</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userTabs.map((tab, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{tab.tabName}</td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={tab.canView}
                              onChange={() => togglePermission(i, "canView")}
                            />
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={tab.canEdit}
                              onChange={() => togglePermission(i, "canEdit")}
                            />
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={tab.canDelete}
                              onChange={() => togglePermission(i, "canDelete")}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <button onClick={handleSave} className="btn btn-primary">
                    Save Permissions
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Permissions;
